import Menu from './Menu';
import Projects from './Projects';
import Contact from './Contact';
import About from './About';
import BurgerMenu from './BurgerMenu';

export default function Main() {
  return (
    <>
      <Menu />
      <BurgerMenu />
      <About />
      <Projects />
      <Contact />
    </>
  );
}
